import React, { Fragment, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import ListGroupsPageTitle from '../../../Layout/AppMain/ListGroupsPageTitle';
import { useHistory } from 'react-router-dom';
import {
    Button,
    Form,
    FormGroup,
    Label,
    Col,
    Card,
    CardBody,
    Container,
} from 'reactstrap';
import * as Yup from 'yup';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../Context/Auth/AuthContext';
import GroupStatuses from '../../../enums/GroupStatuses';

const schema = Yup.object().shape({
    title: Yup.string().required('Title is required!'),
    description: Yup.string().required('Description is required!'),
});

export default function CreateGroup() {
    const { toggleLoading } = useAuth();
    const history = useHistory();
    const { register, errors, handleSubmit, reset } = useForm({
        validationSchema: schema,
    });
    const onSubmit = useCallback(
        async ({ description, title, organization, script, status, hvpn }) => {
            toggleLoading(true);
            try {
                const response = await api.post('/ro.team.createGroup', {
                    description,
                    title,
                    organization,
                    script,
                    hvpn,
                    status: parseInt(status)
                });
                if (response.status === 200) {
                    toast.success('Your group has been created!');
                    reset(response);
                    toggleLoading(false);
                    history.push('/groups');
                }
            } catch (err) {
                toast.error('Something went wrong. Try again!');
                toggleLoading(false);
            }
        },
        [reset, history, toggleLoading]
    );

    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <ListGroupsPageTitle
                    heading="Create a group"
                    subheading="Create a volunteer group to connect with seniors."
                    icon="pe-7s-plus icon-gradient bg-ripe-malin fontWeigth800"
                    showHomeBtn={true}
                />
                <Container fluid>
                    <Card className="main-card mb-3">
                        <CardBody>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <FormGroup row>
                                    <Label for="title" sm={2}>
                                        Title
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            type="text"
                                            name="title"
                                            id="title"
                                            placeholder="Type a name for your group"
                                            ref={register}
                                            className="form-control"
                                        />
                                        {errors.title && (
                                            <p className="error-validation-left">
                                                {errors.title.message}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="description" sm={2}>
                                        Description
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            type="text"
                                            name="description"
                                            id="description"
                                            placeholder="Type a description for your group"
                                            ref={register}
                                            className="form-control"
                                        />
                                        {errors.description && (
                                            <p className="error-validation-left">
                                                {errors.description.message}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="organization" sm={2}>
                                        Organization
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                            type="text"
                                            name="organization"
                                            id="organization"
                                            placeholder="Type the Group organization"
                                            ref={register}
                                            className="form-control"
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="script" sm={2}>
                                        Script
                                    </Label>
                                    <Col sm={10}>
                                        <textarea
                                            name="script"
                                            id="script"
                                            placeholder="Type an optional Script for Volunteers. You can enter it later."
                                            ref={register}
                                            className="form-control"
                                        >
                                        </textarea>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="status" sm={2}>
                                        Group Type
                                    </Label>
                                    <Col sm={4}>
                                        <select
                                            name="status"
                                            id="status"
                                            ref={register}
                                            className="form-control"
                                        >
                                            <option value={GroupStatuses.PRIVATE}>PRIVATE</option>
                                            <option value={GroupStatuses.PUBLIC}>PUBLIC</option>
                                        </select>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="hvpn" sm={2}>
                                        Show Volunteer Phone Number
                                    </Label>
                                    <Col sm={4}>
                                        <select
                                            name="hvpn"
                                            id="hvpn"
                                            ref={register}
                                            className="form-control"
                                        >
                                            <option value={1}>NO</option>
                                            <option value={0}>YES</option>
                                        </select>
                                    </Col>
                                </FormGroup>
                                <FormGroup check row>
                                    <Col sm={{ size: 15, offset: 2 }}>
                                        <Button
                                            type="submit"
                                            value="Submit"
                                            color="success"
                                        >
                                            Create
                                        </Button>
                                        <Button
                                            className="ml-2"
                                            color="secondary"
                                            onClick={(evt) => {
                                                evt.preventDefault();
                                                history.push('/groups');
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Col>
                                </FormGroup>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </CSSTransitionGroup>
        </Fragment>
    );
}
